import * as React from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
    // body has height:100% + overflow-x:hidden which makes it a separate
    // scroll container from the viewport. window.scrollTo only resets
    // documentElement, not body.scrollTop.
    document.body.scrollTop = 0;
  }, [location.key]);

  return null;
};

export default ScrollToTop;
